module.exports = __webpack_public_path__ + "static/media/back-arrow-black.be82a5e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/back-arrow-black.svg
// module id = 873
// module chunks = 21